import styled from "styled-components";

export const Container = styled.div`
//     position: relative;
//     width: 100%;
//     background-color: #f8f6e7;
//     header{
//         position: relative;
//         margin: auto;
//         width: 100%;
//         display: flex;
//         align-items: center;
//         justify-content: center;

//         &::before{
//             height: 134px;
//             content: '';
//             position: absolute;
//             background-color: #4e3628;
//             left: 0;
//             width: 100%;
//             top: 0%;
//             right: 0%;
//         }

//     }
//     .headerContentAuth{
//         max-width: 1420px;
//         width: 90%;
//     }
//     .headerContentAuth nav ul{
       
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         color: white;
//         margin: auto;

//         .left{
//             display: flex;
//             gap: 100px;
//             margin-top: -75px;
//         }

//         .right{
//             display: flex;
//             margin-top: -75px;
//             gap: 100px;
//         }

//         .centerImg{
//             display:flex ;
//             margin-top: 75px;
//             img{
//                 width: 150px;
//             }
//         }

//         li{
//             position: relative;
//             z-index: 1;
//             a{
//                 text-transform: uppercase;
//                 font-size: 16px;
//             }
//             img{
//                 width: 20px;
//             }
//         }

//         .logoArea{
//             img{
//                 margin-left: 40px;
//             }
//         }
       
//         .center{
//             text-align: center;
//             line-height: 20px;
//         }
        
//         img{
//             position: relative;
//             z-index: 1;
//             width: 150px;
//         }
//     }
//     .headerAuth .headerContentAuth nav ul{
//         justify-content: center;
//         gap: 100px;
//     }
//     .central{
//         margin: auto;
//         max-width: 1420px;
//         width: 90%;
//         img{
//             margin: 3rem auto;
//             width: 400px;
//         }
//     }
    
//     .headerContentAuth nav .adjustHeader{
//         display: flex;
//         justify-content: center;
//         gap: 100px;
//     }

//     .headerContentAuth nav .adjustHeader{
//         gap: 25px;
//     }
//     .responsiveHeader{
//         width: 100%;
//         background-color: #4e3628;
//         position: fixed;
//         justify-content: space-between;
//         align-items: center;
//         display: none;
//         z-index: 999;
//         top: 0px;
//         padding: 10px 0px;
//         img{
//             width: 80px;
//         }

//         .responsiveHeaderContent{
//             max-width: 1420px;
//             width: 90%;
//             margin: auto;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//         }
//     }

//     @media (max-width: 1420px) {
//         .headerContentAuth nav ul .right {
//             gap: 25px;
//         }
//         .headerContentAuth nav ul .left {
//             gap: 25px;
//         }
//     }
//     @media (max-width: 1180px) {
//         .central{
//             margin-top: 8rem;
//         }
//         .headerContentAuth ul li:not(:last-child) {
//             margin-right: 30px;
//         }
//         header::before{
//             display: none;
//         }
//         .responsiveHeader{
//             display: flex;
//         }
        
//         .headerContentAuth {
//             position: fixed;
//             transform: translateX(100%); 
//             top: 0;
//             right: 0; 
//             height: 100%;
//             transition: transform ease-in-out 0.6s;
//             overflow: hidden;
//             z-index: 998;
//             background-color: #4e3628;
//             width: 270px;
//         }

//         .headerContentAuth nav ul li a {
//             text-align: left;
//         }

//         .headerContentAuth.active {
//             transform: translateX(0); 
//             transition: transform ease-in-out 0.3s;
//         }

//         .headerContentAuth nav {
//             height: 100%;
//             margin: auto;
//             display: flex;
//         }

//         .headerContentAuth nav ul .right {
//             flex-direction: column;
//             gap: 0px;
//             margin-top: 0px;
//             width: 90%;
//             align-items: center;
//         }
//         .headerContentAuth nav ul .left {
//             flex-direction: column;
//             gap: 0px;
//             margin-top: 0px;
//             width: 90%;
//             align-items: center;
//         }
        
//         .headerContentAuth ul li:not(:last-child) {
//             margin-right: 0px;
//         }
        
//         .adJustLeft br{
//             display: none;
//         }

//         .headerContentAuth nav ul .centerImg {
//         display: none;
//         }

//         .iconsMenu{
//             align-items: center;
//             justify-content: flex-start;
//         }

//         .headerContentAuth ul {
//             display: flex;
//             flex-direction: column;
//         }

//         .headerContentAuth ul li {
//             margin-right: unset;
//             margin-top: 22px;
//         }

//         .headerAuth .headerContentAuth nav ul{
//             gap: 0px;
//         }
//     }

//     @media (max-width: 768px) {
//         .headerContentAuth {
//             width: 100%;
//         }
//     }
`;


export const Icon = styled.div`
   
//    @media (max-width: 1180px) {
//     display: block;
//     position: relative;
//     cursor: pointer;
//     z-index: 999;
//     height: 32px;
//     width: 40px;

//     span {
//       background-color: ${(props) => (props.active ? "transparent" : "white")};
//       border-radius: 3px;
//       position: absolute;
//       width: 40px;
//       height: 3px;
//       top: 50%;
//       left: 0;
//       transform: translateY(-50%);
//       transition: background-color 0.3s ease-in-out;
//     }

//     span::before,
//     span::after {
//       content: "";
//       background-color: white;
//       border-radius: 3px;
//       position: absolute;
//       width: 40px;
//       height: 3px;
//       transition: transform 0.3s ease-in-out, margin-top 0.3s ease-in-out;
//     }

//     span::before {
//       top: ${(props) => (props.active ? "0" : "-12px")};
//       transform: ${(props) => (props.active ? "rotate(45deg)" : "none")};
//     }

//     span::after {
//       top: ${(props) => (props.active ? "0" : "12px")};
//       transform: ${(props) => (props.active ? "rotate(-45deg)" : "none")};
//     }
//   }
`;